import { defineAction } from '~/prix'
import { z } from 'zod'
import creditEconomicMovementCreateAction from './creditEconomicMovementCreate.action.json' with { type: 'json' }
import {
  creditEconomicMovementCreateInputObject,
  creditEconomicMovementObject,
} from '../creditEconomicMovementObject'

const creditEconomicMovementCreateDefinition = defineAction({
  ...creditEconomicMovementCreateAction,

  input: creditEconomicMovementCreateInputObject,
  output: z.object({ id: creditEconomicMovementObject.shape.id }),
})

export default creditEconomicMovementCreateDefinition

